import { generateColumns } from "@features/crud-table/components/generate-columns";
import { useList } from "@features/crud-table/hooks/use-list";
import { useTableColumns } from "@features/crud-table/hooks/use-tables";
import { buildFormFields } from "@features/form/form-schema";
import { useFormStore } from "@features/form/form.store";
import type { Database } from "@shared/types/supabase";
import { createFileRoute } from "@tanstack/react-router";
import { CrudTable } from "@widgets/crud-table/crud-table";
import { useMemo } from "react";

type TableName = keyof Database["public"]["Tables"];

export const Route = createFileRoute("/_authenticated/tables/$resource")({
	component: CrudList,
});

function CrudList() {
	const { resource } = Route.useParams();

	return <CrudListContent key={resource} resource={resource} />;
}

function CrudListContent({ resource }: { resource: TableName }) {
	const { data: columnMetadata, isPending: isColumnsPending } = useTableColumns(resource);
	const { data: rowData, isPending } = useList({ resource });
	const setFormFields = useFormStore((state) => state.setFormFields);

	const columns = useMemo(() => {
		if (!columnMetadata) return [];
		setFormFields(buildFormFields(columnMetadata));
		return generateColumns(columnMetadata);
	}, [columnMetadata, setFormFields]);

	const data = useMemo(() => rowData?.data || [], [rowData]);

	return (
		<div className="w-full">
			<CrudTable
				data={data}
				columns={columns as any}
				isPending={isPending && isColumnsPending}
				columnMetadata={columnMetadata}
			/>
		</div>
	);
}
